import { render } from "./About.vue?vue&type=template&id=10e0b2d8"
const script = {}
script.render = render

export default script